import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '@appStore/customers/actions';
import { CustomerService } from '@appStore/customers/services';

@Injectable()
export class CustomerApprovalEffects {
    constructor(private actions$: Actions, private customerService: CustomerService) {}

    loadDistributionApprovalCustomers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.CustomerApprovalsActionTypes.LoadDistributionApprovalCustomers),
            exhaustMap(() => {
               return this.customerService.getDistributionApprovalCustomers().pipe(
                    map(result => new actions.LoadDistributionApprovalCustomersSuccess(result)),
                    catchError(error => of(new actions.LoadDistributionApprovalCustomersFail(error)))
                );
            })
        );
    });

    loadDelayedDistributionApprovalCustomerIds$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIds),
            exhaustMap(() => {
               return this.customerService.getDelayedDistributionApprovalCustomerIds().pipe(
                    map(result => new actions.LoadDelayedDistributionApprovalCustomerIdsSuccess(result)),
                    catchError(error => of(new actions.LoadDelayedDistributionApprovalCustomerIdsFail(error)))
                );
            })
        );
    });

    delayDistributionApprovalCustomers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.CustomerApprovalsActionTypes.DelayDistributionApprovalCustomers),
            exhaustMap((action: actions.DelayCustomerDistributionApprovals) => {
               return this.customerService.delayCustomerDistributionApproval(action.payload).pipe(
                    map(result => new actions.DelayCustomerDistributionApprovalsSuccess(result)),
                    catchError(error => of(new actions.DelayCustomerDistributionApprovalsFail(error)))
                );
            })
        );
    });

}